var _path, _path2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SUN",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.676,
    height: 68.676,
    viewBox: "0 0 68.676 68.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3288",
    "data-name": "Trac\\xE9 3288",
    d: "M68.676,34.338A34.338,34.338,0,1,1,34.338,0,34.338,34.338,0,0,1,68.676,34.338Z",
    fill: "#a1c6e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3289",
    "data-name": "Trac\\xE9 3289",
    d: "M97.591,54.024H70.108A34.535,34.535,0,0,1,74.655,50H97.591a2.012,2.012,0,0,1,0,4.024Zm7.377,51.641a2.012,2.012,0,0,0,2.012,2.012h4.694a34.416,34.416,0,0,0,5.772-4.024H106.98A2.012,2.012,0,0,0,104.968,105.665Zm18.779-38.9a2.012,2.012,0,0,0-2.012-2.012H115.7a2.012,2.012,0,0,1,0-4.024h9.239a34.369,34.369,0,0,0-2.67-4.024H94.908a2.012,2.012,0,0,0,0,4.024h10.06a2.012,2.012,0,0,1,0,4.024H88.2a2.012,2.012,0,1,0,0,4.024h33.533A2.012,2.012,0,0,0,123.746,66.767Zm5.623,10.06H98.989a2.049,2.049,0,0,0-2.067,1.915,2.012,2.012,0,0,0,2.01,2.109h16.1a2.012,2.012,0,0,1,2.012,2.012,2.012,2.012,0,0,0,2.012,2.012h9.56a34.464,34.464,0,0,0,.768-7.243C129.38,77.362,129.376,77.094,129.37,76.826Z",
    transform: "translate(-60.704 -43.293)",
    fill: "#bbd8f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun_5_",
    "data-name": "sun (5)",
    transform: "translate(8.133 9.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8563",
    "data-name": "Trac\\xE9 8563",
    d: "M51.566,28.28l-3.642,3.745,1.283,5.06a2.978,2.978,0,0,1-2.08,3.6L42.1,42.1l-1.415,5.027a2.978,2.978,0,0,1-3.6,2.08l-5.06-1.283-3.745,3.642a2.979,2.979,0,0,1-4.153,0l-3.745-3.642-5.06,1.283a2.978,2.978,0,0,1-3.6-2.08L10.309,42.1,5.282,40.684a2.978,2.978,0,0,1-2.08-3.6l1.283-5.06L.843,28.28a2.978,2.978,0,0,1,0-4.153l3.642-3.745L3.2,15.322a2.978,2.978,0,0,1,2.08-3.6l5.027-1.415,1.415-5.027a2.978,2.978,0,0,1,3.6-2.08l5.06,1.283L24.128.842a2.979,2.979,0,0,1,4.153,0l3.745,3.642L37.086,3.2a2.978,2.978,0,0,1,3.6,2.08L42.1,10.308l5.027,1.415a2.978,2.978,0,0,1,2.08,3.6l-1.283,5.06,3.642,3.745A2.979,2.979,0,0,1,51.566,28.28Zm0,0",
    transform: "translate(0 0)",
    fill: "#ffde55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8564",
    "data-name": "Trac\\xE9 8564",
    d: "M23.241,63.909c-9.315-11.337-7-27.313-5.5-32.816l-2.421-.614a2.979,2.979,0,0,0-3.6,2.08l-1.415,5.027L5.282,39A2.978,2.978,0,0,0,3.2,42.6l1.283,5.06L.843,51.4a2.978,2.978,0,0,0,0,4.153L4.485,59.3,3.2,64.362a2.978,2.978,0,0,0,2.08,3.6l5.027,1.415L11.724,74.4a2.978,2.978,0,0,0,3.6,2.08l5.06-1.283,3.745,3.642a2.978,2.978,0,0,0,4.152,0l2.271-2.208A43.515,43.515,0,0,0,23.241,63.909Zm0,0",
    transform: "translate(0 -27.277)",
    fill: "#ffc757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8565",
    "data-name": "Trac\\xE9 8565",
    d: "M116.2,98.2A17.994,17.994,0,1,1,98.2,80.207,17.994,17.994,0,0,1,116.2,98.2Zm0,0",
    transform: "translate(-71.997 -71.998)",
    fill: "#ffeb99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8566",
    "data-name": "Trac\\xE9 8566",
    d: "M95.238,133.406c-6.566-7.991-7.354-18.288-6.721-25.6A18,18,0,0,0,98.2,140.972a18.253,18.253,0,0,0,2.006-.11A44.31,44.31,0,0,0,95.238,133.406Zm0,0",
    transform: "translate(-71.997 -96.774)",
    fill: "#ffe36c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.06052e91.svg";
export { ForwardRef as ReactComponent };